import apiService from "../services/api.service";

export interface FeedbackStatusResponse {
	success: boolean;
	message: string;
}

/**
 * Update feedback completion status for an extra
 */
export const updateFeedbackStatus = async (
	extraId: number,
	completed: boolean
): Promise<FeedbackStatusResponse> => {
	const response = await apiService.put(`/extras/${extraId}/feedback`, {
		feedback_completed: completed,
	});
	return response.data;
};
